// Libs
import React, { useState, useEffect } from 'react';
import { Collapse } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
  CrfCicloOrcamentarioProjetoDadosGerais,
  getCicloOrcamentarioProjetoDadosGerais,
} from '@app/api/crf/CrfRelatorioCicloorcamentario';

//Files
import AbaPacote from './AbaPacote';
import AbaGeralRelatorioCicloOrcamentario from './abaGeralRelatorioCicloOrcamentario';
import GraficoPluriAnual from './GraficoPluriAnual'

const CrfRelatorioCicloOrcamentarioProjetoPluriAnual = () => {
  const { Panel } = Collapse;
  const [cicloOrcamentarioProjetoDadosGerais, setCicloOrcamentarioProjetoDadosGerais] = useState<CrfCicloOrcamentarioProjetoDadosGerais>();
  const [projetoId, setProjeto] = useState<string>();

  useEffect(() => {
    var projetoId = new URLSearchParams(window.location.search).get('projetoId');

    if (projetoId) {
      setProjeto(projetoId);
      getCicloOrcamentarioProjetoDadosGerais(projetoId).then(data => {
        setCicloOrcamentarioProjetoDadosGerais(data);
      });
    }
  }, []);

  return (
    <ui.SimpleView>
      <ui.CrudContext.Consumer>
        {() => (
          <ui.CompositeView>
            {true && cicloOrcamentarioProjetoDadosGerais ? (
              <ui.GridView icon="commons-document" id="dadosgerais" noform title="DADOS GERAIS">
                <AbaGeralRelatorioCicloOrcamentario
                  cicloOrcamentarioProjetoDadosGerais={cicloOrcamentarioProjetoDadosGerais}
                />
              </ui.GridView>
            ) : (
              () => { }
            )}
            {projetoId ? (
              <ui.GridView icon="commons-document" id={`pacote`} noform title="Pacote">
                <AbaPacote
                  projetoId={projetoId}
                  pageSize={25}
                  mostrarBotalExportarADistribuir={false}
                  nomeProjeto={''}
                  projetoCodigo={''}
                />
              </ui.GridView>
            ) : (
              () => { }
            )}

            {
              projetoId ? (
                <ui.GridView icon="commons-document" id="cursoEconomica" noform title="Curva Econômica" >
                  <GraficoPluriAnual
                    projetoId={projetoId}
                    exportarCurvaEconomicaPluriAnual={true}
                  />
                </ui.GridView>
              ) : (
                () => { }
              )}
          </ui.CompositeView>
        )}
      </ui.CrudContext.Consumer>
    </ui.SimpleView >
  );
};

export default CrfRelatorioCicloOrcamentarioProjetoPluriAnual;
